var map = {
	"./AllProjects.js": "LKqz",
	"./Calendar.js": "uP3y",
	"./Content.js": "KE4F",
	"./CustomLink.js": "yke8",
	"./Footer/Footer.js": "CN8t",
	"./Footer/index.js": "Fzi1",
	"./FrontHighlightBlock.js": "9Ys2",
	"./Layout.js": "7oih",
	"./LazyCalendar.js": "SVZT",
	"./Mail.js": "bIkF",
	"./Map.js": "SVAT",
	"./Navbar/Navbar.js": "78ew",
	"./Navbar/index.js": "SMfn",
	"./NewsItem.js": "6f/W"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zYCZ";